import { ComparisonState } from '../types';

export const serializeStateToUrl = (state: ComparisonState): string => {
  const url = new URL(window.location.origin + window.location.pathname);
  
  // Paramètres explicites pour les images (plus lisible)
  if (state.beforeImage) url.searchParams.set('before', state.beforeImage);
  if (state.afterImage) url.searchParams.set('after', state.afterImage);
  if (state.title) url.searchParams.set('t', state.title);

  // Le reste de la config est compressé dans un seul paramètre 'c'
  const slimConfig = {
    bl: state.beforeLabel,
    al: state.afterLabel,
    bd: state.beforeDesc,
    ad: state.afterDesc,
    or: state.orientation,
    vm: state.viewMode,
    sp: state.splitPosition,
    sc: state.separatorColor,
    sw: state.separatorWidth,
    blpx: state.beforeLabelPos.x,
    blpy: state.beforeLabelPos.y,
    alpx: state.afterLabelPos.x,
    alpy: state.afterLabelPos.y,
    blsw: state.beforeLabelSize.width,
    blsh: state.beforeLabelSize.height,
    alsw: state.afterLabelSize.width,
    alsh: state.afterLabelSize.height,
    of: state.objectFit,
    ff: state.fontFamily,
    fs: state.fontSize,
    ac: state.accentColor,
    bg: state.bgColor,
    th: state.theme,
    br: state.borderRadius,
    pd: state.padding,
    l: state.language,
    lc: state.labelColor,
    dc: state.descColor
  };

  const base64 = btoa(unescape(encodeURIComponent(JSON.stringify(slimConfig))));
  url.searchParams.set('c', base64);
  
  return url.toString();
};

export const deserializeStateFromUrl = (params: URLSearchParams, initialState: ComparisonState): ComparisonState => {
  const before = params.get('before');
  const after = params.get('after');
  const title = params.get('t');
  const configStr = params.get('c');

  let state = { ...initialState };

  if (before) state.beforeImage = before;
  if (after) state.afterImage = after;
  if (title) state.title = title;

  if (configStr) {
    try {
      const jsonStr = decodeURIComponent(escape(atob(configStr)));
      const s = JSON.parse(jsonStr);
      
      state = {
        ...state,
        beforeLabel: s.bl || state.beforeLabel,
        afterLabel: s.al || state.afterLabel,
        beforeDesc: s.bd || state.beforeDesc,
        afterDesc: s.ad || state.afterDesc,
        orientation: s.or || state.orientation,
        viewMode: s.vm || state.viewMode,
        splitPosition: s.sp ?? state.splitPosition,
        separatorColor: s.sc || state.separatorColor,
        separatorWidth: s.sw ?? state.separatorWidth,
        beforeLabelPos: { x: s.blpx ?? state.beforeLabelPos.x, y: s.blpy ?? state.beforeLabelPos.y },
        afterLabelPos: { x: s.alpx ?? state.afterLabelPos.x, y: s.alpy ?? state.afterLabelPos.y },
        beforeLabelSize: { width: s.blsw ?? state.beforeLabelSize.width, height: s.blsh ?? state.beforeLabelSize.height },
        afterLabelSize: { width: s.alsw ?? state.afterLabelSize.width, height: s.alsh ?? state.afterLabelSize.height },
        objectFit: s.of || state.objectFit,
        fontFamily: s.ff || state.fontFamily,
        fontSize: s.fs ?? state.fontSize,
        accentColor: s.ac || state.accentColor,
        bgColor: s.bg || state.bgColor,
        theme: s.th || state.theme,
        borderRadius: s.br ?? state.borderRadius,
        padding: s.pd ?? state.padding,
        language: s.l || state.language,
        labelColor: s.lc || state.labelColor,
        descColor: s.dc || state.descColor
      };
    } catch (e) {
      console.error("Failed to decode URL config", e);
    }
  }

  return state;
};
